import Axios from 'axios'
import {
	IConfirmImportProductsParams,
	ImportProductsParams,
	IPaginationImportProductTableParams
} from 'models/ProductImport'

const urlApi = '/items/impo'

export const importProductsApi = async (params: ImportProductsParams) => {
	const { archivo, idOperacion } = params
	const formData = new FormData()
	formData.append('archivo', archivo as Blob)
	formData.append('idOperacion', idOperacion)
	formData.append('page_size', '10')
	formData.append('page_number', '1')

	const response = await Axios.post(`${urlApi}/importar`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})

	return response.data
}

export const confirmImportProductsApi = async (
	params: IConfirmImportProductsParams
) => {
	const response = await Axios.post(`${urlApi}/confirmar`, params)
	return response.data
}

export const importProductsPaginationApi = async (
	params: IPaginationImportProductTableParams
) => {
	const response = await Axios.get(`${urlApi}/paginar`, { params })
	return response.data
}
